import { Page } from "../utils/page";
import * as Aos from "aos";
import Splide from '@splidejs/splide';


@Page()
class Home {

  constructor() {
  }

	init() {
		this.hideLoader()
    this.startAos()
    this.initObserver()

	}

	hideLoader() {
		const loader = (document.getElementById('loader') as HTMLElement).classList
		loader.add('hideLoader')
		setTimeout(() => loader.add('hide'), 1000)
	}

  startAos() {
    Aos.init({
    })
  }

  initObserver(){
    let options = {
      threshold: 1.0,
    };

    let observer = new IntersectionObserver(this.initDefer.bind(this), options);
    let target = document.querySelector(".home-banner");
    observer.observe(target);
  }

  initDefer(entries, observer){
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {

        this.startDiffs()
        this.startCertificates()
        this.startProducts()
        this.startCountrys()
        observer.unobserve(document.querySelector(".home-banner"))
      }
    });


  }

  startProducts(){
    new Splide( '#products-carousel',{
      padding: '15%',
      gap: '1em',
      autoplay: true,
      type: 'loop',
      lazyLoad: 'nearby',
    } ).mount();
  }


  startDiffs(){
    var main = new Splide( '#main-carousel', {
      type      : 'fade',
      rewind    : true,
      pagination: false,
      arrows    : false,
      width : '50%',
      lazyLoad : 'nearby',
      autoplay: true,
      interval: 3000,
      rewindSpeed: 3000,
      breakpoints:{
        769:{
          width: '80%'
        }
      }
    } );
    var thumbnails = new Splide( '#thumbnail-carousel', {
      fixedWidth  : 220,
      fixedHeight : 320,
      gap         : '2em',
      rewind      : true,
      pagination  : false,
      isNavigation: true,
      arrows: false,
      breakpoints : {
        769: {
          width: '100%',
          fixedWidth : 50,
          fixedHeight: 50,
        },
      },
    } );

    var current; // Keeps the current thumbnail
    var thumbs = document.getElementsByClassName( 'home-diffs-item' );
    const info = document.getElementById('diffs-info')
    main.on( 'move', function () {
      if ( current ) {
        current.classList.remove( 'is-active' );
      }

      // Splide#index returns the latest slide index:
      var thumbnail = thumbs[ main.index ];

      if ( thumbnail ) {
        info.innerHTML = thumbnail.querySelector('span').innerHTML
        current = thumbnail;
      }
    } );

    main.sync( thumbnails );
    main.mount();
    thumbnails.mount();
  }

  startCertificates(){
    var deskInit = false;
    var movilInit = false

    if(window.innerWidth > 769){
      const certs = Array.from(document.getElementsByClassName('home-certificates-item'))
      const info = document.getElementById('certs-info')
      for(const cert of certs){
        cert.addEventListener('mouseover',()=>{
          info.innerHTML = cert.getAttribute('data-info')
        })
      }
      deskInit = true;
    }else{
      new Splide( '#certificates-carousel',{
        padding: '15%',
        gap: '1em',
        autoplay: true,
        lazyLoad: 'nearby',
        type: 'loop'
      } ).mount();
      movilInit = true
    }

    window.addEventListener("resize", (event) => {
      if(deskInit==false && window.innerWidth > 769){
        const certs = Array.from(document.getElementsByClassName('home-certificates-item'))
        const info = document.getElementById('certs-info')
        for(const cert of certs){
          cert.addEventListener('mouseover',()=>{
            info.innerHTML = cert.getAttribute('data-info')
          })
        }
        deskInit = true;
      }
      if(movilInit == false && window.innerWidth <= 769){
        new Splide( '#certificates-carousel',{
          padding: '15%',
          gap: '1em',
          autoplay: true,
          lazyLoad: 'nearby',
          type: 'loop'
        } ).mount();
        movilInit = true
      }

    });


  }

  startCountrys(){
    new Splide( '#countrys-carousel',{
      autoplay: true,
      type: 'loop',
      lazyLoad: 'nearby',
      arrows: false,

      interval: 4000,
    } ).mount();
  }

}
